import { useEffect } from 'react';

const BASE_TITLE = 'Code — AI Traffic Light';

/**
 * Sets the browser tab title for the current page.
 * Restores the base title on unmount.
 *
 * @param title - Page-specific title segment (e.g. "Dashboard").
 *                Pass `undefined` or empty string to show only the base title.
 */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
